/** @returns {Immutable.OrderedSet<ItemRecord>} */
const getItems = state => state.items.items

/**
 * @template {Immutable.List<string> | Immutable.OrderedSet<string>} T
 * @param {object} state
 * @param {T} itemIds
 * @returns {T extends Immutable.List ? Immutable.List<ItemRecord> : Immutable.OrderedSet<ItemRecord>}
 */
export const getItemsByIds = (state, itemIds) => itemIds.map(itemId => getItems(state).get(itemId))

/**
 * @param state
 * @param {string} itemId
 * @returns {?ItemRecord}
 */
export function selectItemById(state, itemId) {
  return getItems(state).get(itemId)
}
